import { create } from 'zustand';
import { Org } from '@/types';

interface OrgStore {
  env: 'prod' | 'dev';
  token: string | null;
  authType: 'otp' | 'auth0';
  orgs: Org[];
  currentOrg: Org | null;
  setEnv: (env: 'prod' | 'dev') => void;
  setToken: (token: string | null) => void;
  setAuthType: (authType: 'otp' | 'auth0') => void;
  setOrgs: (orgs: Org[]) => void;
  setCurrentOrg: (org: Org) => void;
  updateOrg: (orgId: string, updates: Partial<Org>) => void;
}

export const useOrgStore = create<OrgStore>((set) => ({
  env: 'prod',
  token: null,
  authType: 'otp',
  orgs: [],
  currentOrg: null,
  setEnv: (env: 'prod' | 'dev') => set({ env }),
  setToken: (token: string | null) => set({ token }),
  setAuthType: (authType: 'otp' | 'auth0') => set({ authType }),
  setOrgs: (orgs: Org[]) => set({ orgs }),
  setCurrentOrg: (org: Org) => set({ currentOrg: org }),
  updateOrg: (orgId: string, updates: Partial<Org>) =>
    set((state) => {
      const updatedOrgs = state.orgs.map((org) => {
        if (org.orgid === orgId) {
          return {
            ...org,
            ...updates,
            // Deep merge nested branding object
            branding: updates.branding
              ? { ...org.branding, ...updates.branding }
              : org.branding,
          };
        }
        return org;
      });

      // Also update currentOrg if it matches the updated org
      const updatedCurrentOrg =
        state.currentOrg?.orgid === orgId
          ? updatedOrgs.find((org) => org.orgid === orgId) || state.currentOrg
          : state.currentOrg;

      // Sync currentOrg to localStorage if it was updated
      if (updatedCurrentOrg && state.currentOrg?.orgid === orgId) {
        localStorage.setItem('currentOrg', JSON.stringify(updatedCurrentOrg));
      }

      return {
        orgs: updatedOrgs,
        currentOrg: updatedCurrentOrg,
      };
    }),
}));
